import { render, staticRenderFns } from "./Drawers.vue?vue&type=template&id=3e486f28"
import script from "./Drawers.vue?vue&type=script&lang=js"
export * from "./Drawers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports